"use strict";

var _classCallCheck = require("/home/rodrigo/repo/clinica-oral-prime-gatsby-landing/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/rodrigo/repo/clinica-oral-prime-gatsby-landing/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AngleUpdater = void 0;

var Enums_1 = require("../../Enums");

function updateAngle(particle, delta) {
  var _a;

  var rotate = particle.options.rotate;
  var rotateAnimation = rotate.animation;
  var speed = ((_a = particle.rotate.velocity) !== null && _a !== void 0 ? _a : 0) * delta.factor;
  var max = 2 * Math.PI;

  if (!rotateAnimation.enable) {
    return;
  }

  switch (particle.rotate.status) {
    case Enums_1.AnimationStatus.increasing:
      particle.rotate.value += speed;

      if (particle.rotate.value > max) {
        particle.rotate.value -= max;
      }

      break;

    case Enums_1.AnimationStatus.decreasing:
    default:
      particle.rotate.value -= speed;

      if (particle.rotate.value < 0) {
        particle.rotate.value += max;
      }

      break;
  }
}

var AngleUpdater = /*#__PURE__*/function () {
  function AngleUpdater() {
    _classCallCheck(this, AngleUpdater);
  }

  _createClass(AngleUpdater, [{
    key: "isEnabled",
    value: function isEnabled(particle) {
      var rotate = particle.options.rotate;
      var rotateAnimation = rotate.animation;
      return !particle.destroyed && !particle.spawning && !rotate.path && rotateAnimation.enable;
    }
  }, {
    key: "update",
    value: function update(particle, delta) {
      if (!this.isEnabled(particle)) {
        return;
      }

      updateAngle(particle, delta);
    }
  }]);

  return AngleUpdater;
}();

exports.AngleUpdater = AngleUpdater;